
import Vue from "vue";
import TextField from "@/components/molecules/TextField.vue";
import ButtonDefault from "@/components/atoms/ButtonDefault.vue";
import SignUpConfirmCode from "@/components/organisms/SignUpConfirmCode.vue";
import { Auth } from "aws-amplify";
import { Tutorial } from "@/lib/models/tutorial";
import { writerTypeIndicatorRequestType } from "@/store/modules/writerTypeIndicator";

interface Data {
  email: string;
  password: string;
  passwordConfirm: string;
  message: string;
  errorMessage: string;
  inputConfirmCode: boolean;
}

interface Computed {
  help: string;
}

interface Methods {
  complete(): Promise<void>;
  submit(): Promise<void>;
}

export default Vue.extend<Data, Methods, Computed, unknown>({
  components: { ButtonDefault, TextField, SignUpConfirmCode },
  data() {
    return {
      email: "",
      password: "",
      passwordConfirm: "",
      message: "",
      errorMessage: "",
      inputConfirmCode: false,
    };
  },
  computed: {
    help() {
      return process.env.VUE_APP_NOTION_HELP!;
    },
  },
  methods: {
    async complete() {
      const { email, password, $store } = this;
      await Auth.signIn(email, password);

      // 作家タイプ診断のゲストデータ確認
      const requestType: writerTypeIndicatorRequestType = "signup";
      this.$store.dispatch("writerTypeIndicatorModule/checkGuestResult", requestType);

      // サンプルデータを作成
      await $store.dispatch("generalModule/createSampleData");

      // チュートリアルデータを作成してトップページへ
      const tutorial: Tutorial = {
        screen: "home",
        category: "first",
        step: "before",
      };
      await $store.dispatch("tutorialModule/createTutorial", {
        tutorial,
      });
      this.$router.push({ name: "home" });
    },
    async submit() {
      const { email, password, passwordConfirm } = this;
      if (!password || !email) {
        this.errorMessage = this.$t("signUpPage.validation.emailAndPasswordRequired") as string;
        return;
      }
      if (password !== passwordConfirm) {
        this.errorMessage = this.$t("signUpPage.validation.passwordMismatch") as string;
        return;
      }
      // eslint-disable-next-line no-useless-escape
      if (!email.match(/^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+$/)) {
        this.errorMessage = this.$t("signUpPage.validation.invalidEmailFormat") as string;
        return;
      }

      try {
        await Auth.signUp({
          username: email,
          password,
        });
        this.message = this.$t("signUpPage.validation.emailSent") as string;
        this.errorMessage = "";
        this.inputConfirmCode = true;
      } catch (err: any) {
        if (err.code === "UsernameExistsException") {
          this.errorMessage = this.$t("signUpPage.validation.emailAlreadyExists") as string;
        } else if (err.code === "InvalidParameterException" || err.code === "InvalidPasswordException") {
          this.errorMessage = this.$t("signUpPage.validation.invalidPassword") as string;
        } else if (err.code === "LimitExceededException") {
          this.errorMessage = this.$t("signUpPage.validation.limitExceeded") as string;
        } else {
          console.log(err);
          this.errorMessage = `${this.$t("signUpPage.validation.genericError")}: ${err}`;
        }
      }
    },
  },
});
